import firebase from 'firebase/app'
import { getStore } from './store'
import firedb from 'firebase/database'

let db = null
let viewsparkDB = null

function initDB () {
  let firebaseConfig = getStore().getState().config.firebase
  firebase.initializeApp(firebaseConfig)
  db = {
    firebase: firebase,
    charityDatabase: firebase.database().ref(getStore().getState().config.charityId)
  }

  viewsparkDB = new ViewsparkDatabase(db)

  db.viewspark = viewsparkDB

  return db
}

export class ViewsparkDatabase {
  constructor (db) {
    this.db = db
  }
}

export default function database () {
  if (db === null) {
    return initDB()
  } else {
    return db
  }
}
